import { makeRoute } from '~/utils/route';

import template from './e2e-ktable.html';
import controller from './e2e-ktable.controller';

export default makeRoute({
	template,
	controller,
	title:      'e2e ktable',
	path:       '/e2e/ktable',
	onlyDev:    true,
});
